
import { getMaterialInfo } from '@/api/res_store/info';
import { fmtSize } from '@/filters/index';
import * as api from '@/config/api';
import { NODE_ENV } from '@com/config/env';

export default {
  data: function data() {
    return {
      bLoading: true,
      tableData: [],
      sId: '',
      oInfo: {},
      sPreviewUrl: ''
    };
  },

  methods: {
    getFileTableData: function getFileTableData() {
      if (this.oInfo.file_list && this.oInfo.file_list.length) {
        var aFileTemp = [];
        this.oInfo.file_list.forEach(function (e) {
          var item = {};
          var extTemp = e.name.split('.');
          var extFile = String(extTemp[extTemp.length - 1]).toLowerCase();
          item.name = e.name;
          item.ext = extFile;
          item.size = e.size;
          aFileTemp.push(item);
        });
        return aFileTemp;
      }
      return [];
    },
    previewData: function previewData() {
      var fileArr = [];
      var url = '';
      var data = '';
      if (this.oInfo.preview_urls.length > 0) {
        this.oInfo.preview_urls.forEach(function (e) {
          var aTemp = e.split('/');
          fileArr.push(aTemp[aTemp.length - 1]); // 获取单个文件名称
        });
        url = this.oInfo.preview_urls[0].split(fileArr[0])[0]; // 获取文件列表路径
      }

      data = {
        files: fileArr,
        url: url
      };
      return data;
    }
  },
  computed: {
    tagTypeName: function tagTypeName() {
      var name = '';
      if (Number(this.oInfo.cat1_id) === 1) {
        name = '龙骨动画';
      } else {
        name = '序列帧动画';
      }
      return name;
    },
    targetUrl: function targetUrl() {
      var data = {
        development: '/common-viewer/animation.html', // 使用测试环境预览地址
        test: '/common-viewer/animation.html',
        production: '/common-viewer/animation.html'
      };
      return data[NODE_ENV];
    },

    downloadUrl: {
      get: function get() {
        return api.resStoreDownloadUrl;
      }
    },
    fileFormat: {
      get: function get() {
        if (this.oInfo.file_list && this.oInfo.file_list.length) {
          var aFileTemp = [];
          this.oInfo.file_list.forEach(function (e) {
            var aTemp = e.name.split('.');
            var sFile = String(aTemp[aTemp.length - 1]).toLowerCase();
            if (['json', 'png'].indexOf(sFile) !== -1) {
              aFileTemp.push(sFile + '（' + fmtSize(e.size) + '）');
            }
          });
          return aFileTemp.join();
        }
        return '';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.sId = this.$route.params.id;
    if (this.$route.params.id) {
      this.bLoading = true;
      getMaterialInfo({
        id: this.$route.params.id
      }).then(function (res) {
        _this.oInfo = res.data.data.info;
        _this.bLoading = false;
        _this.tableData = _this.getFileTableData();
        var sName = _this.oInfo.name.length > 20 ? _this.oInfo.name.substr(0, 20) + '...' : _this.oInfo.name;
        document.querySelector('.app-breadcrumb .u-breadcrumb-cur').innerHTML = '详情: ' + sName;
        var urlData = _this.previewData();
        var targetUrl = _this.targetUrl;
        _this.sPreviewUrl = targetUrl + '?type=' + _this.oInfo.cat1_id + '&url=' + encodeURIComponent(urlData.url) + '&list=' + encodeURIComponent(urlData.files.map(function (e) {
          return e;
        }).join());
      }).catch(function () {
        _this.bLoading = false;
      });
    }
  }
};